export enum Views {
  InitialPage = 'InitialPage',
  InitialPageLst = 'InitialPageLst',
  ReportPage = 'ReportPage',
  AboutPage = 'AboutPage',
  HowItWorksPage = 'HowItWorksPage',
  SkeletonPage = 'SkeletonPage',
  Login = 'Login',
  Manage = 'Manage',
  Remediations = 'Remediations',
  LstUpgrade = 'LstUpgrade',
}
